export const minLengthValidatorKey = 'minLength';
export const minLengthValidator = (minLength) => {
    return (value) => {
        const isValid = !!value && value.length >= minLength;
        return {
            [minLengthValidatorKey]: isValid,
        };
    };
};
//# sourceMappingURL=min-length.validator.js.map